import { render } from "./TheScooters.vue?vue&type=template&id=4db3c9d0"
import script from "./TheScooters.vue?vue&type=script&lang=js"
export * from "./TheScooters.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__